/**
 * F-04 온보딩 완료 플래그.
 * 플래그는 localStorage 단일 키 — 서버 온보딩 상태 RPC가 생기면 그쪽을
 * 신뢰 원천으로 교체한다(UF-1 E2 재개 로직 포함).
 */

export const ONBOARDED_STORAGE_KEY = "ty-onboarded";

export function isOnboarded(): boolean {
  try {
    return localStorage.getItem(ONBOARDED_STORAGE_KEY) === "1";
  } catch {
    return false; // 프라이빗 모드 등 storage 접근 불가 — 미완료로 간주
  }
}

export function markOnboarded(): void {
  try {
    localStorage.setItem(ONBOARDED_STORAGE_KEY, "1");
  } catch {
    // storage 불가 시 조용히 무시 — 홈 배너가 한 번 더 뜨는 것 이상의 해가 없다
  }
}
